<template>
  <div>
    <div v-if="isLoading" class="loading-overlay">
      <img src="../assets/images/login/loader_ebh.gif" style="width: 10%" />
      <p style="font-size: 20px; font-weight: 500">Loading...</p>
    </div>

    <div v-else>
      <div class="atas-card mr-5">
        <div class="row mr-5">
          <div
            class="d-xl-block d-lg-block d-md-block d-sm-none d-none"
            style="
              width: 32px;
              height: 32px;
              padding-left: 200px;
              padding-top: 20px;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M27.7675 7.35875C27.6736 7.24642 27.5562 7.15607 27.4236 7.09408C27.291 7.03209 27.1464 6.99998 27 7H6.835L6.22375 3.6425C6.14003 3.18167 5.89723 2.76484 5.53767 2.46468C5.17812 2.16452 4.72462 2.00007 4.25625 2H2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3C1 3.26522 1.10536 3.51957 1.29289 3.70711C1.48043 3.89464 1.73478 4 2 4H4.25L7.445 21.5362C7.53911 22.0563 7.76895 22.5423 8.11125 22.945C7.63881 23.3863 7.29781 23.9498 7.12607 24.573C6.95433 25.1962 6.95856 25.8549 7.13829 26.4759C7.31801 27.0968 7.66622 27.6559 8.14428 28.0911C8.62235 28.5263 9.2116 28.8205 9.8467 28.9412C10.4818 29.062 11.1379 29.0044 11.7423 28.775C12.3467 28.5456 12.8758 28.1533 13.2708 27.6416C13.6658 27.1299 13.9114 26.5187 13.9804 25.8759C14.0493 25.2332 13.9388 24.5838 13.6613 24H19.3388C19.115 24.4684 18.9993 24.981 19 25.5C19 26.1922 19.2053 26.8689 19.5899 27.4445C19.9744 28.0201 20.5211 28.4687 21.1606 28.7336C21.8001 28.9985 22.5039 29.0678 23.1828 28.9327C23.8617 28.7977 24.4854 28.4644 24.9749 27.9749C25.4644 27.4854 25.7977 26.8617 25.9327 26.1828C26.0678 25.5039 25.9985 24.8001 25.7336 24.1606C25.4687 23.5211 25.0201 22.9744 24.4445 22.5899C23.8689 22.2053 23.1922 22 22.5 22H10.3962C10.1621 22 9.93532 21.9177 9.75554 21.7677C9.57576 21.6176 9.45436 21.4092 9.4125 21.1787L9.01625 19H23.5163C24.2188 18.9999 24.8991 18.7532 25.4384 18.303C25.9777 17.8527 26.3419 17.2275 26.4675 16.5362L27.9875 8.17875C28.0132 8.0343 28.0069 7.88596 27.9688 7.74424C27.9308 7.60253 27.8621 7.47092 27.7675 7.35875ZM12 25.5C12 25.7967 11.912 26.0867 11.7472 26.3334C11.5824 26.58 11.3481 26.7723 11.074 26.8858C10.7999 26.9993 10.4983 27.0291 10.2074 26.9712C9.91639 26.9133 9.64912 26.7704 9.43934 26.5607C9.22956 26.3509 9.0867 26.0836 9.02882 25.7926C8.97094 25.5017 9.00065 25.2001 9.11418 24.926C9.22771 24.6519 9.41997 24.4176 9.66665 24.2528C9.91332 24.088 10.2033 24 10.5 24C10.8978 24 11.2794 24.158 11.5607 24.4393C11.842 24.7206 12 25.1022 12 25.5ZM24 25.5C24 25.7967 23.912 26.0867 23.7472 26.3334C23.5824 26.58 23.3481 26.7723 23.074 26.8858C22.7999 26.9993 22.4983 27.0291 22.2074 26.9712C21.9164 26.9133 21.6491 26.7704 21.4393 26.5607C21.2296 26.3509 21.0867 26.0836 21.0288 25.7926C20.9709 25.5017 21.0007 25.2001 21.1142 24.926C21.2277 24.6519 21.42 24.4176 21.6666 24.2528C21.9133 24.088 22.2033 24 22.5 24C22.8978 24 23.2794 24.158 23.5607 24.4393C23.842 24.7206 24 25.1022 24 25.5ZM24.5 16.1787C24.458 16.4098 24.3361 16.6187 24.1555 16.7689C23.975 16.919 23.7473 17.0008 23.5125 17H8.6525L7.19875 9H25.8013L24.5 16.1787Z"
                fill="#191717"
              />
            </svg>
          </div>
          <div class="" style="padding-left: 50px; padding-top: 25px">
            <span
              style="
                color: var(--neutral-07, #191717);
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 18px;
                letter-spacing: -0.16px;
              "
              >Keranjang Belanja Anda</span
            >
          </div>
        </div>
      </div>

      <section class="bg6 p-t-15" style="padding-right: 10px">
        <div class="container">
          <div id="isi_cart">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-8">
                <div class="cart-judul mr-2">
                  <b-form-checkbox
                    class=""
                    type="checkbox"
                    id="selectAll"
                    v-model="selectAllChecked"
                    @change="updateAllCheckboxes"
                    size="lg"
                  ></b-form-checkbox>
                  <!-- <input
                    type="checkbox"
                    id="selectAll"
                    class="mr-2"
                    v-model="selectAllChecked"
                    @change="updateAllCheckboxes"
                  /> -->
                  <span
                    class="mt-2"
                    style="
                      color: var(--primary-04, #3860a8);
                      font-size: 14px;
                      font-style: normal;
                      font-weight: 600;
                      line-height: 15.4px; /* 110% */
                      letter-spacing: -0.14px;
                    "
                    >Pilih Semua</span
                  >
                </div>

                <br />
                <div v-if="loading" class="skeleton-loader">
                  <!-- Add your skeleton structure here -->
                  <div class="skeleton-item" v-for="n in 3" :key="n"></div>
                </div>

                <!-- Show empty state if loading is false and groupedCart is empty -->
                <div v-else-if="!groupedCart.length" class="empty-cart">
                  <img
                    src="https://img.freepik.com/free-vector/empty-shopping-basket-concept-illustration_114360-22411.jpg?uid=R54119371&ga=GA1.1.1157040633.1730791735&semt=ais_hybrid"
                    alt="Empty Cart"
                  />
                  <p>
                    Ups!! Keranjang Kosong,
                    <router-link :to="'/'"> Ayo Belanja </router-link>
                  </p>
                </div>
                <div
                  style="border-radius: 10px"
                  v-for="cartGroup in groupedCart"
                  :key="cartGroup.mall_id"
                >
                  <div class="cart-card1 mr-2 mt-3">
                    <div class="d-flex">
                      <!-- <input
        type="checkbox"
        class="mr-2"
        v-model="cartGroup.isGroupChecked"
        @change="updateGroupCheckboxes(cartGroup)"
      /> -->
                      <span v-if="cartGroup.mall"
                        ><b>{{ cartGroup.mall }}</b></span
                      >
                      <span v-else><b>Tidak ada toko</b></span>
                    </div>
                    <!-- <div @click="deleteManufacturer(cartGroup.manufacturer_id)">
                    
                    </div> -->
                  </div>
                  <div
                    style="width: 99%; height: 1px; background: #cbcbcb"
                  ></div>
                  <div
                    style="background-color: white; width: 99%"
                    v-for="product in cartGroup.products"
                    :key="product.id_cart"
                  >
                    <div class="d-lg-none container">
                      <div
                        style="padding: 15px"
                        class="d-flex align-items-center"
                      >
                        <b-form-checkbox
                          type="checkbox"
                          class="mr-2"
                          v-model="product.is_checked"
                          @change="
                            updateCart(
                              product.id_cart,
                              product.qty,
                              product.is_checked
                            )
                          "
                          size="lg"
                        ></b-form-checkbox>
                        <!-- <input
                          type="checkbox"
                          class="mr-2"
                          v-model="product.is_checked"
                          @change="
                            updateCart(
                              product.id_cart,
                              product.qty,
                              product.is_checked
                            )
                          "
                        /> -->
                        <div style="position: relative; display: inline-block">
                          <img
                            :src="getProductImage(product)"
                            @error="handleImageError($event, product)"
                            alt="Gambar Produk"
                            style="
                              width: 80px;
                              height: 100px;
                              margin-right: 10px;
                            "
                          />

                          <span
                            v-if="product.discount"
                            style="
                              font-size: 10px;
                              position: absolute;
                              top: 4px;
                              right: 14px;
                              background-color: red;
                              color: white;
                              padding: 5px 8px;
                              border-radius: 20px;
                            "
                            ><b>{{ product.discount }}%</b></span
                          >
                        </div>
                        <td>
                          <div
                            @click="handleProductClick(product)"
                            style="text-align: left"
                          >
                            <span
                              style="
                                color: var(--neutral-07, #191717);
                                font-size: 16px;
                                font-weight: 500;
                                font-style: normal;
                                line-height: 15.4px;
                                letter-spacing: -0.14px;
                                cursor: pointer;
                              "
                            >
                              {{ product.nama_produk }}
                            </span>
                          </div>

                          <div class="flex-l-m">
                            <div class="d-flex">
                              <b-icon
                                v-if="product.qty > 0"
                                icon="dash-square-fill"
                                style="width: 35px; height: 35px"
                                class="custom-icon mr-2"
                                @click="decrementQty(product)"
                              ></b-icon>

                              <b-form-input
                                v-model="product.qty"
                                type="text"
                                class="custom-spin-button text-center"
                                readonly
                              ></b-form-input>

                              <b-icon
                                v-if="product.qty > 0"
                                icon="plus-square-fill"
                                style="width: 35px; height: 35px"
                                class="custom-icon"
                                @click="incrementQty(product)"
                              ></b-icon>
                            </div>
                            <span class="pl-2" style="padding: 12px 0px"
                              >Stok
                              <span
                                style="
                                  padding: 12px 0px;
                                  color: var(--primary-05, #244786);
                                "
                                >{{ product.stok }}</span
                              >
                            </span>
                          </div>
                          <div
                            class="d-flex col-3 col-md-2 px-2 mb-2 text-center"
                          >
                            <span
                              v-if="product.discount"
                              style="
                                color: var(--primary-05, #244786);
                                font-size: 14px;
                                font-style: normal;
                                line-height: 18px;
                                letter-spacing: -0.16px;
                                margin-top: 5px;
                              "
                              class="mr-2 text-left"
                            >
                              <s style="color: var(--neutral-04, #989898)">
                                Rp{{
                                  product.originalPrice
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                                }}</s
                              >
                            </span>
                            <span
                              style="
                                color: var(--primary-05, #244786);
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 600;
                                line-height: 18px;
                                letter-spacing: -0.16px;
                                margin-top: 5px;
                              "
                              class="text-left"
                            >
                              Rp{{
                                product.price
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                              }}
                            </span>
                            <div
                              class="pl-2"
                              @click="deleteProduct(product.id_cart)"
                            >
                              <b-icon
                                style="margin-top: 5px"
                                icon="trash"
                                scale="1.3"
                                variant="danger"
                              ></b-icon>
                            </div>
                          </div>
                          <input
                            class="harga"
                            type="hidden"
                            name="harga[]"
                            value="52000"
                          />
                          <input
                            class="berat"
                            type="hidden"
                            name="berat[]"
                            value="0.15"
                          />
                        </td>
                      </div>
                    </div>
                    <div class="d-none d-lg-block container">
                      <div class="row">
                        <div class="col-lg-5">
                          <div
                            style="padding: 15px"
                            class="d-flex align-items-center"
                          >
                            <b-form-checkbox
                              type="checkbox"
                              class="mr-2"
                              v-model="product.is_checked"
                              @change="
                                updateCart(
                                  product.id_cart,
                                  product.qty,
                                  product.is_checked
                                )
                              "
                              size="lg"
                            ></b-form-checkbox>
                            <div
                              style="position: relative; display: inline-block"
                            >
                              <img
                                :src="getProductImage(product)"
                                @error="handleImageError($event, product)"
                                alt="Gambar Produk"
                                style="
                                  width: 80px;
                                  height: 100px;
                                  margin-right: 10px;
                                "
                              />

                              <!-- Menampilkan badge diskon hanya jika diskon tersedia -->
                              <span
                                v-if="product.discount"
                                style="
                                  font-size: 10px;
                                  position: absolute;
                                  top: 4px;
                                  right: 14px;
                                  background-color: red;
                                  color: white;
                                  padding: 5px 8px;
                                  border-radius: 20px;
                                "
                              >
                                <b>{{ product.discount }}%</b>
                              </span>
                            </div>
                            <td>
                              <div
                                @click="handleProductClick(product)"
                                style="text-align: left"
                              >
                                <span
                                  style="
                                    color: var(--neutral-07, #191717);
                                    font-size: 16px;
                                    font-weight: 500;
                                    font-style: normal;
                                    line-height: 15.4px;
                                    letter-spacing: -0.14px;
                                    cursor: pointer;
                                  "
                                >
                                  {{ truncateText(product.nama_produk, 20) }}
                                </span>
                              </div>
                              <div class="flex-l-m">
                                <!-- Menampilkan harga asli hanya jika ada diskon -->
                                <span
                                  v-if="product.discount"
                                  class="pl-2"
                                  style="padding: 0px 0px"
                                >
                                  <s style="color: var(--neutral-04, #989898)">
                                    Rp{{
                                      product.originalPrice
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                                    }}
                                  </s>
                                </span>
                              </div>
                              <div class="col-3 col-md-2 px-2 mb-2 text-center">
                                <span
                                  style="
                                    color: var(--primary-05, #244786);
                                    font-size: 16px;
                                    font-style: normal;
                                    font-weight: 600;
                                    line-height: 18px;
                                    letter-spacing: -0.16px;
                                  "
                                  class="text-left"
                                >
                                  Rp{{
                                    product.price
                                      .toString()
                                      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                                  }}
                                </span>
                              </div>
                            </td>
                          </div>
                        </div>
                        <div class="col-lg-3">
                          <div class="mt-5">
                            <span class="pl-2" style="padding-right: 70px">
                              Stok
                              <span
                                style="
                                  padding: 12px 0px;
                                  color: var(--primary-05, #244786);
                                "
                              >
                                {{ product.stok }}
                              </span>
                            </span>
                            <div class="d-flex">
                              <b-icon
                                v-if="product.qty > 0"
                                icon="dash-square-fill"
                                style="width: 25px; height: 25px"
                                class="custom-icon mr-2"
                                @click="decrementQty(product)"
                              ></b-icon>
                              <b-form-input
                                v-model="product.qty"
                                type="text"
                                class="custom-spin-button text-center"
                                readonly
                              ></b-form-input>
                              <b-icon
                                v-if="product.qty > 0"
                                icon="plus-square-fill"
                                style="width: 25px; height: 25px"
                                class="custom-icon"
                                @click="incrementQty(product)"
                              ></b-icon>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mt-5">
                            <p>Total Harga</p>
                            <span
                              style="
                                color: var(--primary-05, #244786);
                                font-size: 16px;
                                font-weight: 600;
                                line-height: 18px;
                                letter-spacing: -0.16px;
                              "
                              class="mt-2 text-left"
                            >
                              Rp{{
                                calculateTotalPrice(product.price, product.qty)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div
                            class="mt-5"
                            style="padding-top: 8px"
                            @click="deleteProduct(product.id_cart)"
                          >
                            <b-icon
                              icon="trash"
                              scale="2"
                              variant="danger"
                            ></b-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-12 col-lg-4">
                <br class="d-lg-none" />
                <div class="cart-card">
                  <!-- <div class="mt-2">
                    <button class="button-voucher">
                      <span
                        style="
                          color: var(--primary-04, #3860a8);
                          font-style: normal;
                          line-height: 15.4px;
                          letter-spacing: -0.14px;
                          font-size: 16px;
                          font-weight: 500;
                        "
                      >
                        Gunakan vouchermu disini
                      </span>
                    </button>
                  </div> -->
                  <div class="d-flex justify-content-start mt-3">
                    <span
                      style="
                        color: #000;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 600;
                        text-align: left;
                        line-height: 18px; /* 112.5% */
                        letter-spacing: -0.16px;
                      "
                      >Rincian Belanja</span
                    >
                  </div>
                  <!-- <div class="d-flex justify-content-between mt-4">
                    <span
                      style="
                        color: var(--danger-01, #e91313);
                        font-size: 16px;
                        font-weight: 500;
                        font-style: normal;
                        line-height: 13.2px; /* 110% */
                        letter-spacing: -0.12px;
                      "
                      >Diskon</span
                    ><span style="color: white">haha</span
                    ><span
                      style="
                        color: var(--neutral-04, #989898);

                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 13.2px; /* 110% */
                        letter-spacing: -0.12px;
                      "
                      ><s>Rp 0</s></span
                    >
                  </div> -->
                  <div class="d-flex justify-content-between mt-4">
                    <span
                      style="
                        color: #000;
                        font-size: 16px;
                        font-weight: 500;
                        font-style: normal;
                        line-height: 15.4px; /* 110% */
                        letter-spacing: -0.14px;
                      "
                      >Sub Total (1 item)</span
                    ><span style="color: white">haha</span>
                    <span
                      style="
                        color: var(--primary-05, #244786);
                        font-size: 20px;
                        font-weight: 500;
                        font-style: normal;
                        line-height: 18px; /* 112.5% */
                        letter-spacing: -0.16px;
                      "
                    >
                      {{ formatPrice(totalAllProduct) }}
                    </span>
                  </div>
                  <div class="mt-2">
                    <button @click="bayarSekarang" class="button-co">
                      <span
                        style="
                          color: var(--neutral-01, #fefefe);
                          font-size: 16px;
                          font-weight: 500;
                          font-style: normal;
                          line-height: 15.4px;
                          letter-spacing: -0.14px;
                        "
                      >
                        Bayar Sekarang
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <br />
          </div>
        </div>
      </section>
    </div>
    <div class="mt-5"></div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
export default {
  name: "cartPage",
  data() {
    return {
      product: {
        qty: 0,
      },
      totalAllProduct: 0,
      loading: false,
      selectAllChecked: false,
      isChecked: false,
      groupedCart: [],
      cartGroup: {
        products: [], // Inisialisasi cartGroup.products dengan produk-produk Anda
      },
      value: 1,
    };
  },
  computed: {
    isSelectAllChecked: function () {
      // Check if all products are checked
      return this.groupedCart.every((group) =>
        group.products.every((product) => product.is_checked)
      );
    },
    calculateTotalPrice() {
      return (price, qty) => {
        // Ensure that price and qty are valid numbers
        price = parseFloat(price) || 0;
        qty = parseInt(qty) || 0;

        // Calculate the total price
        return price * qty;
      };
    },
  },

  mounted() {
    this.loading = true;
    this.totalProduct();

    const storedSelectAllChecked = localStorage.getItem("selectAllChecked");
    const idCustomer = localStorage.getItem("id_customer");

    if (storedSelectAllChecked !== null) {
      this.selectAllChecked = JSON.parse(storedSelectAllChecked);
    }

    if (idCustomer) {
      const apiUrl = `https://stagingapi.eurekabookhouse.com/cart/cart?id_customer=${idCustomer}`;

      setTimeout(() => {
        axios
          .get(apiUrl)
          .then((response) => {
            this.groupedCart = response.data.data.groupedCart;
            this.groupedCart.forEach((group) => {
              group.products.forEach((product) => {
                product.is_checked = product.is_checked === 1;
              });
            });
          })
          .catch((error) => {
            console.error("Failed to fetch data from API:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }, 1000);
    } else {
      console.error("id_customer not found in localStorage");
      this.loading = false;
    }
  },
  methods: {
    getProductImage(product) {
      return `https://cdn.eurekabookhouse.co.id/ebh/product/all/${product.image}`;
    },
    handleImageError(event, product) {
      const currentSrc = event.target.src;

      // Cek jika sudah pakai cdn utama, coba fallback ke server staging
      if (currentSrc.includes("cdn.eurekabookhouse.co.id")) {
        event.target.src = `https://stagingapi.eurekabookhouse.com/assets/uplod/product/2024/${product.image}`;
      }
      // Kalau sudah pakai fallback dan tetap gagal, ganti ke gambar default
      else if (
        currentSrc.includes("stagingapi.eurekabookhouse.com/assets/uplod")
      ) {
        event.target.src =
          "https://stagingapi.eurekabookhouse.com/assets/front/images/eureka-bookhouse-bg-grey.jpg";
      }
    },
    handleProductClick(product) {
      // Dispatch an action to set the product_id in the Vuex store
      this.$store.dispatch("setProductId", product.product_id);

      // Navigate to the detail page with the slug as a parameter
      this.$router.push({
        name: "detailprodukPage",
        params: { slug: product.slug },
      });
    },
    async incrementQty(product) {
      const newQty = product.qty + 1;

      // Check if the new quantity exceeds the available stock
      if (newQty > product.stok) {
        // Display an alert indicating insufficient stock
        this.showInsufficientStockAlert();
      } else {
        // Update the quantity only if there is sufficient stock
        product.qty = newQty;

        // Call the updateToCart function to update the cart
        this.updateToCart(product, "add");

        // Call the updateCart function to update the cart with the new quantity
        this.updateCart(product.id_cart, newQty, product.is_checked);

        // After successfully updating the quantity, trigger the notifCart() method
        this.$root.$emit("updateCart");
      }
    },

    decrementQty(product) {
      if (product.qty > 0) {
        if (product.qty === 1) {
          // If the quantity becomes 0 after decrement, ask for confirmation to delete
          this.confirmDeleteProduct(product.id_cart);
        } else {
          product.qty -= 1;

          // Call the updateToCart function to update the cart
          this.updateToCart(product, "reduce");

          // Call the updateCart function to update the cart with the new quantity
          this.updateCart(product.id_cart, product.qty, product.is_checked);

          // After successfully updating the quantity, trigger the notifCart() method
          this.$root.$emit("updateCart");
        }
      }
    },

    showInsufficientStockAlert() {
      Swal.fire({
        confirmButtonColor: "#3860A8",
        icon: "error",
        title: "Gagal Menambah Qty",
        text: "Quantity produk tidak mencukupi.",
      });
    },

    confirmDeleteProduct(id_cart) {
      // Use SweetAlert to confirm deletion
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda ingin menghapus produk dari keranjang?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#3860A8",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          // User clicked 'Yes', delete the product
          this.deleteProduct(id_cart);
        }
      });
    },
    //Update Spin Button Keranjang
    async updateToCart(product, action) {
      const token = localStorage.getItem("token");
      const idCustomer = localStorage.getItem("id_customer");

      const apiUrl = "https://stagingapi.eurekabookhouse.com/cart/addAndReduce";
      const requestData = {
        id_customer: idCustomer,
        id_produk: product.id_produk,
        action: action,
      };

      try {
        const response = await axios.post(apiUrl, requestData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // console.log("API Response:", response.data);
      } catch (error) {
        console.error("API Error:", error);
      }
    },
    truncateText(text, limit) {
      if (text.length > limit) {
        return text.substring(0, limit) + "...";
      }
      return text;
    },

    updateGroupCheckboxesByProduct(id_cart, is_checked) {
      this.groupedCart.forEach((group) => {
        const product = group.products.find((p) => p.id_cart === id_cart);
        if (product) {
          // Update the product checkbox
          product.is_checked = is_checked;

          // Update the group checkbox based on the product checkboxes
          group.isGroupChecked = group.products.every((p) => p.is_checked);
        }
      });

      // Update the "Select All" checkbox based on the group checkboxes
      this.selectAllChecked = this.groupedCart.every(
        (group) => group.isGroupChecked
      );
    },
    updateProduct(id_cart, qty, isChecked) {
      // Implement your logic to update product state (e.g., make an API call if needed)
      this.updateCart(id_cart, qty, isChecked);
    },
    updateAll(newValue) {
      this.groupedCart.forEach((group) => {
        // Update store checkbox
        group.is_checked = newValue;
        this.updateStore(group.mall_id, newValue);

        // Update product checkboxes within each store
        group.products.forEach((product) => {
          product.is_checked = newValue;
          this.updateProduct(product.id_cart, product.qty, newValue);
        });
      });
    },
    updateAllCheckboxes() {
      // Set status checked untuk produk dan grup berdasarkan nilai selectAllChecked
      this.groupedCart.forEach((group) => {
        group.products.forEach((product) => {
          product.is_checked = this.selectAllChecked;
          this.updateCart(product.id_cart, product.qty, this.selectAllChecked);
        });

        // Set nilai isGroupChecked berdasarkan produk yang dicentang di dalam grup
        group.isGroupChecked = group.products.every(
          (product) => product.is_checked
        );
      });

      // Set nilai selectAllChecked berdasarkan produk yang dicentang di dalam semua grup
      this.selectAllChecked = this.groupedCart.every(
        (group) => group.isGroupChecked
      );

      // Simpan nilai selectAllChecked ke localStorage
      localStorage.setItem("selectAllChecked", this.selectAllChecked);

      // Jika semua produk dicentang, aktifkan fungsi updateAll untuk mencentang semua produk
      if (this.selectAllChecked) {
        this.updateAll(true);
      } else {
        // Jika tidak semua produk dicentang, aktifkan fungsi updateAll untuk mencentang semua produk
        this.updateAll(false);
      }
    },
    // Update individual checkbox and check if all checkboxes in the group are checked
    updateIndividualCheckbox(product) {
      const group = this.groupedCart.find(
        (group) => group.mall_id === product.mall_id
      );

      if (group) {
        group.isGroupChecked = group.products.every(
          (p) => p.is_checked === true
        );
        this.selectAllChecked = this.groupedCart.every(
          (g) => g.isGroupChecked === true
        );
      }

      this.updateCart(product.id_cart, product.qty, product.is_checked);
    },

    // Update all checkboxes in a group when the group checkbox is changed
    // updateGroupCheckboxes(group) {
    //   const newValue = group.isGroupChecked;
    //   group.products.forEach((product) => {
    //     product.is_checked = newValue;
    //     this.updateCart(product.id_cart, product.qty, newValue);
    //   });
    //   this.selectAllChecked = this.groupedCart.every(
    //     (g) => g.isGroupChecked === true
    //   );
    // },
    formatPrice(price) {
      // Menggunakan metode ini untuk mengonversi harga ke format Rupiah (Rp) tanpa desimal
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(price);
    },
    totalProduct() {
      const idCustomer = localStorage.getItem("id_customer");
      const token = localStorage.getItem("token");

      axios
        .get(
          `https://stagingapi.eurekabookhouse.com/cart/detailHarga?id_customer=${idCustomer}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          const { data } = response;
          this.totalAllProduct = data.data.totalAllProduct;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    bayarSekarang() {
      const idCustomer = localStorage.getItem("id_customer");
      const token = localStorage.getItem("token");

      // Check if at least one product is checked
      const checkedGroups = this.groupedCart.filter((group) =>
        group.products.some((product) => product.is_checked)
      );

      if (checkedGroups.length === 0) {
        // No product is checked, show SweetAlert message
        Swal.fire({
          icon: "error",
          title: "Ups...",
          confirmButtonColor: "#3860A8",
          text: "Sepertinya belum ada produk yang kamu pilih",
        });
        return; // Do not proceed to checkout
      }

      // Check if all checked products are from the same mall
      const mallIds = checkedGroups.map((group) => group.mall_id);
      const uniqueMallIds = [...new Set(mallIds)];

      if (uniqueMallIds.length > 1) {
        // Products from different malls are selected, show SweetAlert message
        Swal.fire({
          icon: "warning",
          title: "Ups...",
          confirmButtonColor: "#3860A8",
          text: "Kamu hanya bisa memilih produk dari toko yang sama",
        });
        return; // Do not proceed to checkout
      }

      // Products are from the same mall, proceed to checkout
      axios
        .get(
          `https://stagingapi.eurekabookhouse.com/shipping/detail/checkout?customer_id=${idCustomer}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          localStorage.setItem("checkoutData", JSON.stringify(response.data));
          this.$router.push("/checkout");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },

    async updateCart(id_cart, qty, is_checked) {
      const token = localStorage.getItem("token");
      const idCustomer = localStorage.getItem("id_customer");

      const requestData = {
        customer_id: idCustomer,
        id_cart: id_cart,
        qty: 0,
        is_checked: is_checked,
      };

      try {
        const response = await axios.put(
          "https://stagingapi.eurekabookhouse.com/cart/updateCart",
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // Handle the response here, for example, you can check if the update was successful.
        // console.log("Update successful", response.data);

        // Update the group checkboxes after successful update
        this.updateGroupCheckboxesByProduct(id_cart, is_checked);

        // Fetch and update the total products without reloading the page
        this.totalProduct();
      } catch (error) {
        // Handle errors, e.g., network issues, or a failed request.
        console.error("Error updating cart", error);
      }
    },

    calculateTotal() {
      this.totalPrice = this.product.price * this.product.qty;
    },
    updateQty() {
      // Lakukan sesuatu saat qty berubah
      // Misalnya, Anda dapat mengirim nilai ini ke server untuk menyimpannya.
      // Contoh sederhana:
      // console.log("Qty has changed to: " + this.product.qty);
    },
    deleteMall(mallId) {
      const idCustomer = localStorage.getItem("id_customer");
      const url = `https://stagingapi.eurekabookhouse.com/cart/delete/manufactur`;
      const data = {
        customer_id: idCustomer,
        mall_id: mallId,
      };

      axios
        .delete(url, { data: data })
        .then((response) => {
          // Hapus manufacturer dari groupedCart langsung
          this.groupedCart = this.groupedCart.filter(
            (group) => group.mall_id !== mallId
          );

          // Tampilkan SweetAlert setelah berhasil
          Swal.fire({
            icon: "success",
            title: "Sukses",
            text: "Data berhasil dihapus!",
            confirmButtonColor: "#3860A8",
          });
        })
        .catch((error) => {
          // Tampilkan SweetAlert untuk pesan kesalahan jika diperlukan
          Swal.fire({
            confirmButtonColor: "#3860A8",
            icon: "error",
            title: "Gagal",
            text: "Gagal menghapus data: " + error.message,
          });
        });
    },
    deleteProduct(id_cart) {
      const token = localStorage.getItem("token");
      const idCustomer = localStorage.getItem("id_customer");

      const deleteData = {
        customer_id: idCustomer,
        id_cart: id_cart,
      };

      axios
        .delete("https://stagingapi.eurekabookhouse.com/cart/delete", {
          data: deleteData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            // Hapus produk dari groupedCart langsung
            this.groupedCart.forEach((group, groupIndex) => {
              group.products = group.products.filter(
                (product) => product.id_cart !== id_cart
              );

              // Jika tidak ada produk lagi dari produsen, hapus produsen
              if (group.products.length === 0) {
                this.groupedCart.splice(groupIndex, 1);
              }
            });
          } else {
            console.error(
              "Gagal menghapus produk. Status code:",
              response.status
            );
          }
        })
        .catch((error) => {
          console.error("Gagal menghapus produk:", error);
        });
    },
  },
  watch: {
    // Watch for changes in the state of the "Select All" checkbox and update all checkboxes accordingly
    selectAllChecked: {
      handler: function (newVal, oldVal) {
        this.updateAll(newVal);
      },
    },
  },
};
</script>

<style type="text/css">
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.custom-spin-button {
  width: 40px; /* Adjust as needed */
  font-size: 12px;
  height: 25px;
}

.custom-icon {
  cursor: pointer;
  margin-left: 5px;
}
.custom-icon:hover {
  cursor: pointer;
  margin-left: 5px;
  color: #5178be;
}
.button-co {
  display: flex;
  height: 42px;
  width: 100%;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 10px;
  background: var(--primary-04, #3860a8);
}
.button-voucher {
  display: flex;
  height: 42px;
  width: 100%;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 10px;
  background: var(--primary-01, #d2e2ff);
}
.full-width-button {
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 10px;
  background: var(--primary-01, #d2e2ff);
  border: none; /* Hapus border tombol jika tidak diperlukan */
}
.atas-card {
  width: 100%;
  height: 72px;
  flex-shrink: 0;
  background-image: url("../assets/images/navbar/bg-keranjang.png"); /* Gambar sebagai latar belakang */
  background-size: cover; /* Pastikan gambar mengisi seluruh area */
  background-position: center; /* Posisikan gambar agar tidak terpotong */
  background-repeat: no-repeat; /* Hindari pengulangan gambar */
}

.cart-card1 {
  display: flex;
  /* width: 775px; */
  height: 40px;
  padding: 15px;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--neutral-01, #fefefe);
}
.cart-card2 {
  /* display: flex; */
  /* width: 775px; */
  padding: 15px;
  /* justify-content: space-between; */
  /* align-items: flex-start; */
  background: var(--neutral-01, #fefefe);
}
.cart-card3 {
  display: flex;
  /* width: 775px; */
  padding: 15px;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 0px 0px 10px 10px;
  background: var(--neutral-01, #fefefe);
}
.cart-card {
  /* display: flex; */
  padding: 15px;
  align-items: flex-start;
  border-radius: 10px;
  background: var(--neutral-01, #fefefe);
}
.cart-judul {
  padding: 15px;
  display: flex;
  align-items: flex-start;
  border-radius: 10px;
  background: var(--neutral-01, #fefefe);
}
.scrollable-menu {
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}
.text1l {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  min-width: 1px;
}
td:not(:last-child) {
  white-space: nowrap;
  width: 1px;
}
.transfer-group-table {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  min-width: 1px;
}
/*	.img-produk-cart{width: 20%;}*/
.img-produk-cart img {
  width: 50px;
}
.mobile-nav {
  display: none;
}
.js-del-cart {
  height: 30px;
  padding: 0.5rem;
  line-height: 1;
}
.skeleton-loader {
  display: flex;
  flex-direction: column;
}

.skeleton-item {
  height: 100px;
  background-color: #e0e0e0;
  border-radius: 8px;
  margin-bottom: 8px;
}

.empty-cart {
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
}

.empty-cart img {
  width: 200px;
  height: auto;
}
</style>
